<header class="dian-header">
    <div class="dian-header__govco" [class.no-image]="urlLogoGovCo === ''">
        <a target="_blank" [href]="links.co"><img [src]="urlLogoGovCo" alt="gov.co"></a>
    </div>
    @if (!govCoHeaderOnly) {
    <div class="dian-header__content" [class.wide-logo]="menuButton && urlLogoDian !== ''">
        <div class="dian-header__content--menu-logo">
            <div class="dian-header__content--menu-logo__menu">
                @if (menuButton) {
                <button (click)="onClickMenu.emit()">
                    <span class="two-line-menu-icon"></span>
                </button>
                }
            </div>
            <div class="dian-header__content--menu-logo__logo"  [class.no-image]="menuButton && urlLogoDian === ''"
                 [class.deafult-image]="urlLogoDian === ''">
                <a target="_blank"  [href]="links.dian"><img [src]="urlLogoDian" alt="logo dian"></a>
            </div>
        </div>
        <div class="dian-header__content--title">
            <h1>{{title}}</h1>
        </div>
        <div class="dian-header__content--optional">
            <ng-content></ng-content>
        </div>
    </div>
    }
</header>
